module.exports = __webpack_public_path__ + "media/application/images/icons/external-link-e229155fc8faa8551446607eeccb861d.svg";